
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/[chartId]",
      function () {
        return require("private-next-pages/embed/[chartId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/[chartId]"])
      });
    }
  